import {Cell} from '@/models/Cell';
import {Grid} from '@/models/Grid';

export class Bar {
	
	private _cell: Cell;
	private _right: boolean = false;
	private _bottom: boolean = false;
	private _topRight: boolean = false;
	private _bottomRight: boolean = false;
	
	constructor(cell: Cell) {
		this._cell = cell;
	}
	
	public get cell(): Cell {
		return this._cell;
	}
	
	public get right(): boolean {
		return this._right;
	}
	
	public get bottom(): boolean {
		return this._bottom;
	}
	
	public get topRight(): boolean {
		this.fix();
		return this._topRight;
	}
	
	public get bottomRight(): boolean {
		return this._bottomRight;
	}
	
	public set right(value: boolean) {
		this.fix();
		this._right = value;
	}
	
	public set bottom(value: boolean) {
		this.fix();
		this._bottom = value;
	}
	
	public set topRight(value: boolean) {
		this.fix();
		this._topRight = value;
	}
	
	public set bottomRight(value: boolean) {
		this.fix();
		this._bottomRight = value;
	}
	
	///////////////
	// Next cell //
	///////////////
	
	public get left(): boolean {
		const cell = this.cell;
		return cell.grid.getCell(cell.x - 1, cell.y).bar.right;
	}
	
	public set left(value: boolean) {
		const cell = this.cell;
		cell.grid.getCell(cell.x - 1, cell.y).bar.right = value;
	}
	
	public get top(): boolean {
		const cell = this.cell;
		return cell.grid.getCell(cell.x, cell.y - 1).bar.bottom;
	}
	
	public set top(value: boolean) {
		const cell = this.cell;
		cell.grid.getCell(cell.x, cell.y - 1).bar.bottom = value;
	}
	
	public get topLeft(): boolean {
		const cell = this.cell;
		return cell.grid.getCell(cell.x - 1, cell.y - 1).bar.bottomRight;
	}
	
	public set topLeft(value: boolean) {
		const cell = this.cell;
		cell.grid.getCell(cell.x - 1, cell.y - 1).bar.bottomRight = value;
	}
	
	public get bottomLeft(): boolean {
		const cell = this.cell;
		return cell.grid.getCell(cell.x - 1, cell.y + 1).bar.topRight;
	}
	
	public set bottomLeft(value: boolean) {
		const cell = this.cell;
		cell.grid.getCell(cell.x - 1, cell.y + 1).bar.topRight = value;
	}
	
	///////////
	// Other //
	///////////
	
	public fix(): void {
		this.cell.fix();
	}
	
	public clone(cell: Cell): Bar {
		const bar = new Bar(cell);
		bar._right       = this._right;      
		bar._bottom      = this._bottom;     
		bar._topRight    = this._topRight;   
		bar._bottomRight = this._bottomRight;
		return bar;
	}
	
	public toJSON(): any {
		return {
			right: this._right,
			bottom: this._bottom,
			topRight: this._topRight,
			bottomRight: this._bottomRight,
		}
	}
	
	public fromJSON(data: any): this {
		this._right = data.right;
		this._bottom = data.bottom;
		this._topRight = data.topRight;
		this._bottomRight = data.bottomRight;
		return this;
	}
	
}